import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import LoginPage from "./components/LoginPage";
import UserLoginPage from "./components/UserLoginPage";
import UserRegisterPage from "./components/UserRegisterPage";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import EmailVerificationPage from "./components/EmailVerificationPage";
import AdminPage from "./components/AdminPage";
import VolumePage from "./components/VolumePage";
import TemasPage from "./components/TemasPage";
import TemaDetail from "./components/TemaDetail";
import EvangelioPage from "./components/EvangelioPage";
import AboutPage from "./components/AboutPage";
import DocumentosListPage from "./components/DocumentosListPage";
import DocumentoViewPage from "./components/DocumentoViewPage";
import AdminDocumentosPage from "./components/AdminDocumentosPage";
import ProfileCompletionModal from "./components/ProfileCompletionModal";
import { AuthProvider } from "./contexts/AuthContext";
import { DarkModeProvider } from "./contexts/DarkModeContext";

// Session Expired Notification Component
const SessionExpiredNotification = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const handleSessionExpired = (event) => {
      setMessage(event.detail.message);
      setShow(true);
      
      // Auto-hide after 5 seconds
      setTimeout(() => {
        setShow(false);
      }, 5000);
    };

    window.addEventListener('sessionExpired', handleSessionExpired);
    
    return () => {
      window.removeEventListener('sessionExpired', handleSessionExpired);
    };
  }, []);

  if (!show) return null;

  return (
    <div className="fixed top-4 right-4 z-50 bg-red-500 text-white px-6 py-4 rounded-lg shadow-lg animate-in slide-in-from-top-2 duration-300">
      <div className="flex items-center">
        <svg className="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
        <span className="font-medium">{message}</span>
      </div>
    </div>
  );
};

function App() {
  return (
    <DarkModeProvider>
      <AuthProvider>
        <div className="App">
          <SessionExpiredNotification />
          <ProfileCompletionModal />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/user-login" element={<UserLoginPage />} />
              <Route path="/register" element={<UserRegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/verify-email" element={<EmailVerificationPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/volume/:volumeNumber" element={<VolumePage />} />
              <Route path="/temas" element={<TemasPage />} />
              <Route path="/tema/:temaId" element={<TemaDetail />} />
              <Route path="/evangelio" element={<EvangelioPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/documentos" element={<DocumentosListPage />} />
              <Route path="/documentos/:slug" element={<DocumentoViewPage />} />
              <Route path="/admin/documentos" element={<AdminDocumentosPage />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </DarkModeProvider>
  );
}

export default App;